import { useState } from "react";
import styles from "./styles.module.scss";
import img1 from './img/1.png'
import img2 from './img/2.png'
import img3 from './img/3.png'
import img4 from './img/4.png'
import img5 from './img/5.png'
import img6 from './img/6.png'
import img7 from './img/7.png'

import { Button } from "@common/index";
import { openModal } from "@utils/modal";
import { Modal } from "./Modal";
import { IconCard, IconCardCheckbox } from "src/routes/onboarding/shared";

const data = [
  {
    value: "Lack of motivation",
    displayValue: "Lack of motivation",
    emoji: img1
  },
  {
    value: "Time constraints ",
    displayValue: "Time constraints ",
    emoji: img2
  },
  {
    value: "Didn't have a clear plan ",
    displayValue: "Didn't have a clear plan ",
    emoji: img3
  },
  {
    value: "Lack of visible progress ",
    displayValue: "Lack of visible progress ",
    emoji: img4
  },
  {
    value: "Workouts were too hard ",
    displayValue: "Workouts were too hard ",
    emoji: img5
  },
    {
    value: "Bad coaching",
    displayValue: "Bad coaching",
    emoji: img6
  },
];
export const SetbacksBefore = ({ onNextStep, onTrackEvent }) => {
  const [checked, setChecked] = useState([]);

  const handleCheck = (value) => {
    setChecked((prevState) => {
      if (prevState.includes(value)) {
        return prevState.filter((item) => item !== value);
      }

      return [...prevState, value];
    });
  };

  const handleNextStep = () => {
    onNextStep?.(checked);
    onTrackEvent?.(checked);
  };

  const openThanksModal = () => {
    openModal(<Modal onContinue={handleNextStep} />);
  };

  const handleSelectNone = () => {
    setChecked([]);
    openThanksModal();
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>Have you struggled with any of these setbacks before?</h2>
        <div className={styles.cards}>
          {data.map((value) => (
            <IconCardCheckbox
              checked={checked.includes(value.value)}
              onClick={() => handleCheck(value.value)}
              img={value.emoji}
              title={value.displayValue}
              key={value.value}
               variant='walky'
            />
          ))}
          <IconCard
            title="None of the above"
            img={img7}
            onClick={handleSelectNone}
          />
        </div>
      </div>
      <div className={styles.action}>
        <Button variant='walky' disabled={!checked.length} onClick={openThanksModal}>
          Continue
        </Button>
      </div>
    </div>
  );
};
